import { VALID_FDI_ISO_NUMBERS } from '../config';

const isValidIso = (iso: number) =>
  (VALID_FDI_ISO_NUMBERS as readonly number[]).includes(iso);

export const resolveNeighbourToothIsos = (iso: number): number[] => {
  if (!isValidIso(iso)) {
    return [];
  }

  return [iso - 1, iso + 1].filter(
    (candidate) =>
      isValidIso(candidate) &&
      Math.floor(candidate / 10) === Math.floor(iso / 10),
  );
};
